export default function getGeneSnpCount(geneName, expectedSnps = {}, geneColors = {}) {
  const expectedCount = expectedSnps?.[geneName]?.length ?? 0;
  const colorCount = geneColors?.[geneName]?.snpColor?.length ?? 0;

  return Math.max(expectedCount, colorCount);
}
